'use strict'

const dialogScript = () => {
    const buttons = document.querySelectorAll('[data-dialog-id]')
    const closeButton = document.querySelectorAll('[data-dialog-close]')
    const body = document.querySelector('body')

    const openDialog = (dialogId, src) => {
        const dialog = document.getElementById(dialogId)

        if (dialog) {
            body.classList.add('overflow-hidden')
            const iframe = dialog.querySelector('iframe')
            if (src) {
                const srcContainer = dialog.querySelector('.dialog__src-container')
                if (srcContainer) {
                    srcContainer.src = src
                }
            }
            dialog.showModal()
            setTimeout(() => {
                if (iframe) {
                    toggleIframeVideo(dialog, 'play')
                }
            }, 100)
        }
    }

    const closeDialog = (dialog) => {
        if (dialog) {
            body.classList.remove('overflow-hidden')

            const video = dialog.querySelector('video')
            if (video && !video.paused) {
                video.pause()
            }

            const iframe = dialog.querySelector('iframe')
            if (iframe) {
                toggleIframeVideo(dialog, 'pause')
            }

            const srcContainer = dialog.querySelector('.dialog__src-container')
            if (srcContainer) {
                srcContainer.src = ''
            }
            dialog.close()
        }
    }

    buttons.forEach((button) => {
        button.addEventListener('click', () => {
            const dialogId = button.getAttribute('data-dialog-id')
            const src = button.getAttribute('data-dialog-src')
            openDialog(dialogId, src)
        })

        button.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault()
                const dialogId = button.getAttribute('data-dialog-id')
                const src = button.getAttribute('data-dialog-src')
                openDialog(dialogId, src)
            }
        })
    })

    closeButton.forEach((button) => {
        button.addEventListener('click', () => {
            const dialog = button.closest('dialog')
            closeDialog(dialog)
        })

        button.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault()
                const dialog = button.closest('dialog')
                closeDialog(dialog)
            }
        })
    })

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            const openDialogs = document.querySelectorAll('dialog[open]')
            openDialogs.forEach((dialog) => {
                closeDialog(dialog)
            })
        }
    })

    document.querySelectorAll('dialog').forEach((dialog) => {
        dialog.addEventListener('click', (event) => {
            const rect = dialog.getBoundingClientRect()
            const isInDialog =
                event.clientX >= rect.left &&
                event.clientX <= rect.right &&
                event.clientY >= rect.top &&
                event.clientY <= rect.bottom
            if (!isInDialog) {
                closeDialog(dialog)
            }
        })
    })
}

const triggerIframeEvent = (iframeContent, command) => {
    if (!iframeContent) {
        return
    }

    try {
        iframeContent.postMessage(
            JSON.stringify({
                event: 'command',
                func: `${command}Video`,
                args: ''
            }),
            '*'
        )

        if (command === 'play') {
            iframeContent.postMessage('{"event":"listening"}', '*')
        }
    } catch (error) {
        // Silent fail
    }
}

const toggleIframeVideo = (dialog, command) => {
    if (!dialog) {
        return
    }

    const iframe = dialog.querySelector('iframe')
    if (!iframe) {
        return
    }

    const iframeContent = iframe.contentWindow
    if (!iframeContent) {
        return
    }

    const srcOpen = iframe.dataset.srcOpen

    if (srcOpen) {
        const updatedSrc = addYouTubeParameters(srcOpen)

        iframe.addEventListener(
            'load',
            () => {
                const delay = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) ? 1000 : 100
                setTimeout(() => {
                    triggerIframeEvent(iframeContent, command)
                }, delay)
            },
            { once: true }
        )

        iframe.src = updatedSrc
        delete iframe.dataset.srcOpen
    } else {
        triggerIframeEvent(iframeContent, command)
    }
}

const addYouTubeParameters = (url) => {
    const urlObj = new URL(url)
    const params = new URLSearchParams(urlObj.search)
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)

    params.set('enablejsapi', '1')
    params.set('autoplay', '1')
    params.set('playsinline', '1')
    params.set('rel', '0')

    if (isMobile) {
        params.set('mute', '1')
    }

    urlObj.search = params.toString()
    return urlObj.toString()
}

export const dialog = (() => {
    const init = () => {
        dialogScript()
    }

    return { init }
})()
